import { FiscalPeriodStringTransformations } from "../../GeneralLedger/utilities/FiscalPeriodStringTransformations";

interface Item {
  jeType: string;
  docNo: string;
  publishedState: string;
  href: string;
  refGuid: string;
  postedBy: string;
  assignedReviewer: string[];
  postingPeriod: string;
  opsDetailId: number;
  jeTaskName: string;
  assignedPoster: string;
}

export function GetLinkToDetailsFromChecklistItem<T extends Item>(
  item: T
): {
  stringContent: string;
  url: string | null;
} | null {
  if (!item) return null;
  if (item.jeType.toLowerCase().indexOf("draft") !== -1 && !item.docNo) return null;
  if (!(item.publishedState.toLowerCase() === "published"))
    return {
      stringContent: item.docNo,
      url: null
    };

  let pathname = "";
  let url: string | null = null;
  let stringContent: string = item.docNo;
  if (item.href && item.href !== "") {
    const div = document.createElement("div");
    // replace #// with #/ to make it a valid url
    item.href = item.href.replace("#//", "#/");
    div.textContent = item.href;
    const tempDoc = new DOMParser().parseFromString(item.href, "text/html");
    const a = tempDoc.querySelector("a");
    if (a) {
      const href = a.href;
      const jemHyperLinkUrl = new URL(href);
      const hash = jemHyperLinkUrl.hash;
      const jeIdParam = "jeId=";

      let jeId: string | null = null;
      if (hash && hash.indexOf(jeIdParam) !== -1) {
        const startIndex = hash.indexOf(jeIdParam) + jeIdParam.length;
        const endIndex = hash.indexOf("&", startIndex) !== -1 ? hash.indexOf("&", startIndex) : hash.length;
        jeId = hash.substring(startIndex, endIndex);
        if (jeId) {
          pathname = "/gl/details";
          url = `?jeid=${jeId}`;
        }
      }
      // If jeId not found in hash, check query string
      if (!jeId) {
        const params = new URLSearchParams(jemHyperLinkUrl.search);
        if (params.has("jeid")) {
          jeId = params.get("jeid");
          if (jeId) {
            pathname = "/gl/details";
            url = `?jeid=${jeId}`;
          }
        }
      }
      let batchRefGuid: string | null = null;
      // Get RefGuid from the query string of jemHyperLinkUrl
      const refGuidParam = "RefGuid";
      const params = new URLSearchParams(jemHyperLinkUrl.search);
      if (params.has(refGuidParam)) {
        batchRefGuid = params.get(refGuidParam);
      }
      if (batchRefGuid) {
        const urlToBatch = new URLSearchParams();
        pathname = "/gl/search/batch";
        if (item.assignedPoster) {
          urlToBatch.set("AliasType", "P");
          urlToBatch.set("Alias", item.assignedPoster.toString());
        } else if (item.assignedReviewer && item.assignedReviewer.length > 0) {
          urlToBatch.set("AliasType", "R");
          urlToBatch.set("Alias", item.assignedReviewer[0].toString());
        } else {
          // Default fallback if neither poster nor reviewer is available
          urlToBatch.set("AliasType", "R");
          urlToBatch.set("Alias", "");
        }
        const fyfp = FiscalPeriodStringTransformations.FiscalPeriodStringToFiscalYearAndFiscalMonth(item.postingPeriod);
        urlToBatch.set("FiscalYear", fyfp?.fiscalYear?.toString() ?? "");
        urlToBatch.set("FiscalMonth", fyfp?.fiscalMonth?.toString() ?? "");
        urlToBatch.set("OpsDetailId", item.opsDetailId.toString());
        urlToBatch.set("BatchName", item.jeTaskName.toString());
        urlToBatch.set("cBatchName", item.jeTaskName.toString());
        urlToBatch.set("cBatchRefGuid", item.refGuid);
        stringContent = "Link to Batch";
        url = `?${urlToBatch.toString()}`;
      }
    }
  }

  if (url === null) {
    if (item.jeType.indexOf("Batch") !== -1 || item.jeType.indexOf("Bulk") !== -1) {
      pathname = "/gl/batch";
      url = `?batchRefGuid=${item.refGuid}`;
    } else {
      pathname = "/gl/details";
      url = `?jeid=${item.refGuid}`;
    }
  }

  return {
    stringContent,
    url: `${pathname}${url}`
  };
}
